module.exports = __webpack_public_path__ + "img/edeaf-journey.0d0b0d8c.jpg";